<template src="./template.html" />

<script>
import { Stage, Button } from '@neurotrack/web-shared-components'
import essComponentProps from '@/mixins/essComponentProps'
import InstructionsContainer from '@/components/InstructionsContainer'
import FillImage from '@/components/FillImage'

export default {
  name: 'instructions_header_image_two_button',
  components: {
    InstructionsContainer, Stage, Button, FillImage
  },
  mixins: [essComponentProps],
  computed: {
    image() {
      return this.trialData?.body?.image?.filename
    },
    leadingButton() {
      return this.trialData?.footer?.leading_button
    },
    trailingButton() {
      return this.trialData?.footer?.trailing_button
    }
  }
}
</script>

<style scoped lang="scss">
@import './style.scss';
</style>
